import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Button, Box } from '@bigcommerce/big-design';

import { purchaseOrderUpdateExternalItem } from '../../redux/actions/purchaseOrders';

const UpdateExternalItemModal = ({ payload, showUpdateExternalItemModal, setShowUpdateExternalItemModal, updateItem, currentId, currentName, currentSku, currentPrice }) => {
  const [name, setName] = useState(null);
  const [sku, setSku] = useState(null);
  const [price, setPrice] = useState(null);

  const changeName = (event) => {
    let value = event.target.value;
    setName(value);
  }

  const changeSku = (event) => {
    let value = event.target.value;
    setSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value;
    setPrice(value);
  }


  const update = () => {
    let itemData = {};

    itemData.productId = currentId;
    itemData.variantId = null;
    itemData.is_external = true;
    itemData.productName = name || currentName;
    itemData.supplier_sku = sku || currentSku;
    itemData.supplier_price = price || currentPrice;
    itemData.minimumOrder = 1;

    updateItem(payload, itemData);
    setShowUpdateExternalItemModal(false);

    setName(null);
    setSku(null);
    setPrice(null);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowUpdateExternalItemModal(false),
          },
          { text: 'Update External Item', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header={`Update External Item: ${currentName}`}
        isOpen={showUpdateExternalItemModal}
        onClose={() => setShowUpdateExternalItemModal(false)}
      >
        <Box
          backgroundColor="warning10"
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          <div>
            <Text>External items should be used sparingly, for products not tracked by your BigCommerce store.</Text>
          </div>
        </Box>

        <Input
          label="Item Name"
          onChange={changeName}
          placeholder={currentName}
          type="text"
          value={name}
          required
        />
        
        <Input
          label="Supplier SKU"
          onChange={changeSku}
          placeholder={currentSku}
          type="text"
          value={sku}
          required
        />

        <Input
          label="Price"
          onChange={changePrice}
          placeholder={currentPrice}
          type="number"
          value={price}
          required
        />

      </Modal>
    </>
  )

}

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => ({
  updateItem: (payload, itemData) => dispatch(purchaseOrderUpdateExternalItem(payload, itemData))

});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateExternalItemModal);
